import React from 'react';
import { FormattedMessage } from 'react-intl';
import { InputBox } from '../../../molecules/input-box';
import { emailSchema } from '../../../utils/zod-utils';

export const SettingsInstallation = () => {
  return (
    <>
      <InputBox
        title={
          <FormattedMessage
            id="settings.service.customer"
            defaultMessage="Jméno uživatele"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.service.customer-subtitle"
            defaultMessage="Slouží k identifikaci instalace pro firmu i zákazníka"
          />
        }
        inputVariableId="CUSTOMER"
        label={
          <FormattedMessage
            id="settings.service.customer.label"
            defaultMessage="Jméno"
          />
        }
        fullWidth
      />
      <InputBox
        title={
          <FormattedMessage
            id="settings.service.customer-email"
            defaultMessage="Email uživatele"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.service.customer-email-subtitle"
            defaultMessage="Pokud nemá uživatel založen účet pod tímto emailem, dojde k automatickému vytvoření účtu a odeslání registračního emailu"
          />
        }
        inputVariableId="CUSTOMER_EMAIL"
        label={
          <FormattedMessage
            id="settings.service.customer-email.label"
            defaultMessage="Email"
          />
        }
        schema={emailSchema}
        fullWidth
      />
      <InputBox
        title={
          <FormattedMessage
            id="settings.service.service-email"
            defaultMessage="Email servisní firmy"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.service.service-email-subtitle"
            defaultMessage="Pro propojení zařízení s instalačním účtem je nutné zadat email servisní firmy, který je uložen v Partnerské sekci aplikace"
          />
        }
        inputVariableId="SERVICE_EMAIL"
        label={
          <FormattedMessage
            id="settings.service.service-email.label"
            defaultMessage="Email"
          />
        }
        schema={emailSchema}
        fullWidth
      />
      <InputBox
        title={
          <FormattedMessage
            id="settings.service.servicer"
            defaultMessage="Jméno instalačního technika"
          />
        }
        inputVariableId="SERVICER"
        label={
          <FormattedMessage
            id="settings.service.servicer.label"
            defaultMessage="Jméno"
          />
        }
        fullWidth
      />
      <InputBox
        title={
          <FormattedMessage
            id="settings.service.solidsun_op"
            defaultMessage="SolidSun OP"
          />
        }
        inputVariableId="SOLIDSUN_OP_NUMBER"
        visibility={{ variableId: 'SOLIDSUN_KZ_API_ENABLED' }}
        label={
          <FormattedMessage
            id="settings.service.solidsun_op.label"
            defaultMessage="SolidSun OP"
          />
        }
        fullWidth
      />
    </>
  );
};
